<template>
    <div class="order-terms">
        <h1>Order Terms</h1>
        <p>to our AI application.Please read the following order terms carefully, which constitute a legal agreement between you and PicChatBox.</p>
        
        <div class="term-section">
            <h2>1. Subscription Plan</h2>
            <p>We offer different subscription plans, including monthly, quarterly and annual subscriptions. Please refer to the in-app description for specific features and prices.</p>
        </div>
        
        <div class="term-section">
            <h2>2. Automatic Renewal</h2>
            <p>· Subscriptions are automatically renewed by default unless you cancel before the end of the current subscription period. The renewal fee will be automatically deducted from the payment method you choose.</p>
            <p>· If the renewal fails due to insufficient deduction balance or abnormal account, you will be responsible for it. If you do not choose to cancel this service on your own, we may continue to provide you with automatic renewal service when/after your account returns to normal and the balance is sufficient (the specific details are subject to the rules of each third-party payment channel). Once the deduction is successful, your service will be restored.</p>
            <p>· If you wish to change the auto-renewal package after activating this service, please cancel this service first, and then repurchase this service after selecting the auto-renewal package you wish.</p>
            <p>· If the service price is adjusted before/at the time of automatic renewal, the current effective price shall prevail.</p>
        </div>
        
        <div class="term-section">
            <h2>3. Cancellation and Refund Policy</h2>
            <p>· You can cancel your subscription at any time. After cancellation, you can still use the services within the subscription period.</p>
            <p>· Except where required by law, all orders are non-refundable.</p>
        </div>
        
        <div class="term-section">
            <h2>4. Free Trial</h2>
            <p>Some subscription plans may offer a free trial period. After the free trial period ends, it will automatically convert to a paid subscription unless you cancel before the end of the trial period.</p>
        </div>
        
        <div class="term-section">
            <h2>5. Payment</h2>
            <p>· Pay through the App Store and all transactions are securely encrypted.</p>
            <p>· You are responsible for providing valid payment information and ensuring that there are sufficient funds in your account.</p>
        </div>
        
        <div class="term-section">
            <h2>6. Restrictions on Use</h2>
            <p>· Subscriptions are for personal use only and may not be used for commercial purposes or shared with others.</p>
            <p>· Violation of usage restrictions may result in account suspension or termination.</p>
        </div>
        
        <div class="term-section">
            <h2>7. Modification and Termination</h2>
            <p>· We reserve the right to modify or terminate the service at any time. Any major changes will be notified in advance.</p>
            <p>· If we terminate your account, you will be notified accordingly and may receive a refund for unused services.</p>
        </div>
        
        <div class="term-section">
            <h2>8. Limitation of Liability</h2>
            <p>· We are not responsible for any direct or indirect damages arising from the use of or inability to use the service.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderTerms'
}
</script>

<style scoped>
/* 保留现有样式 */
.order-terms {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
    text-align: left;
}

h1 {
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
}

h2 {
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 10px;
}

.term-section {
    margin-bottom: 20px;
}

p {
    line-height: 1.6;
    margin-bottom: 10px;
}
</style>